exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#users[data-v-1e38cbc0]{margin:12px;margin-top:36px}#users .top[data-v-1e38cbc0]{margin-bottom:12px}#users .users .column[data-v-1e38cbc0]{font-size:large}#users .users .column .main[data-v-1e38cbc0]{font-weight:bold;margin-top:6px}#users .users .column .main i.icon[data-v-1e38cbc0]{margin-right:20px}", ""]);

// exports
